<script setup lang="ts">

</script>

<template>
  <div class="list-item-card">
    <slot />
  </div>
</template>

<style scoped>
.list-item-card {
  @apply flex bg-explorer-blue/5 rounded-lg p-4
}
</style>